export type Armor = {
  mark: string;
  name: string;
  phase: string;
  year: string;
  description: string;
  features: string[];
  stats: { mobility: number; defense: number; firepower: number; deployment: number };
  accent: string;
  form: 'forge' | 'classic' | 'flight' | 'modular' | 'heavy' | 'nano' | 'legacy';
};

export const armors: Armor[] = [
  {
    mark: 'MARK I', name: '洞穴原型', phase: '起源阶段', year: '2008', form: 'forge', accent: '#b99b70',
    description: '在资源匮乏与时间压力下诞生的逃生原型。粗重钢板、外露液压与有限续航并不优雅，却第一次把工程能力转化为主动选择：不是制造更多武器，而是为自己争取改变方向的机会。',
    features: ['手工锻造结构', '近距离喷射推进', '生存优先逻辑'],
    stats: { mobility: 28, defense: 62, firepower: 44, deployment: 18 },
  },
  {
    mark: 'MARK III', name: '经典红金', phase: '成型阶段', year: '2008', form: 'classic', accent: '#d89b35',
    description: '首套稳定采用红金配色的成熟战衣，将飞行、姿态控制、掌心推进与完整防护整合为统一系统。它确立了此后装甲的视觉语言，也让技术从封闭实验室进入真正需要承担后果的现实。',
    features: ['红金复合装甲', '稳定飞行控制', '多谱段传感'],
    stats: { mobility: 67, defense: 72, firepower: 64, deployment: 42 },
  },
  {
    mark: 'MARK VII', name: '快速部署', phase: '联盟阶段', year: '2012', form: 'flight', accent: '#f3c86a',
    description: '为高压城市战与即时响应设计，舱式部署让战衣能在移动过程中完成接合。能源、武器与飞行控制的平衡显著提升，象征装甲从个人实验品转向能够参与团队协作的可靠平台。',
    features: ['舱式空中部署', '强化推进阵列', '多任务武器舱'],
    stats: { mobility: 82, defense: 78, firepower: 82, deployment: 74 },
  },
  {
    mark: 'MARK XLII', name: '自主拼装', phase: '重构阶段', year: '2013', form: 'modular', accent: '#e1b35d',
    description: '以分段自主推进实现远程召回与模块化接合，既大胆也不稳定。它记录了一段焦虑、失控与重新认识自我的时期：装甲可以碎裂、迟到或失灵，解决问题的人不能把全部判断交给系统。',
    features: ['分段自主飞行', '远程召回接合', '模块快速替换'],
    stats: { mobility: 75, defense: 66, firepower: 70, deployment: 92 },
  },
  {
    mark: 'MARK XLIV', name: '重装反制', phase: '极限负载', year: '2015', form: 'heavy', accent: '#c58d32',
    description: '面向超重型目标的外骨骼级平台，以体量、冗余部件和持续压制换取控制能力。它并非更轻巧的升级，而是承认不同风险需要不同工具；部署与维护成本也提醒技术力量始终伴随代价。',
    features: ['超重型外骨骼', '轨道备件支援', '高冗余关节'],
    stats: { mobility: 45, defense: 96, firepower: 94, deployment: 32 },
  },
  {
    mark: 'MARK L', name: '纳米响应', phase: '深空阶段', year: '2018', form: 'nano', accent: '#d8a840',
    description: '纳米单元把穿戴、修复与工具生成压缩到近乎即时的响应中，装甲不再只是固定外壳，而成为会随局势重构的系统。高度灵活的代价是能量与材料持续消耗，每次变化都必须服务于明确判断。',
    features: ['纳米快速成型', '动态武器构造', '局部损伤补偿'],
    stats: { mobility: 96, defense: 86, firepower: 96, deployment: 99 },
  },
  {
    mark: 'MARK LXXXV', name: '最终遗产', phase: '遗产阶段', year: '2023', form: 'legacy', accent: '#f3c86a',
    description: '成熟纳米技术与经典装甲轮廓在最终阶段汇合，能力更完整，表达却更克制。它的意义不在于成为数字最大的型号，而在于见证一个人把所有设计、失败与责任收束为一次无法撤回的选择。',
    features: ['成熟纳米架构', '高能量整合', '经典轮廓回归'],
    stats: { mobility: 95, defense: 92, firepower: 98, deployment: 99 },
  },
];

export const missions = [
  {
    id: 'origin', year: '2008', index: '01', title: '《钢铁侠》', subtitle: '装甲诞生', videoId: '8ugaeA-nMTc',
    copy: '一次被迫停下的旅程，让武器制造者看见自己工作的真实后果。第一套装甲首先是逃生工具，随后才成为承诺：技术可以被重新选择用途。',
    link: 'https://www.marvel.com/movies/iron-man',
  },
  {
    id: 'rebuild', year: '2013', index: '02', title: '《钢铁侠3》', subtitle: '装甲之外的身份', videoId: 'f_h95mEd4TI',
    copy: '当装甲被拆散、住所被摧毁，问题转向更根本的一层：如果没有熟悉的外壳，还剩下什么？答案不是更多型号，而是承认恐惧、修复关系，并重新掌握自己的判断。',
    link: 'https://www.youtube.com/watch?v=f_h95mEd4TI',
  },
  {
    id: 'legacy', year: '2019', index: '03', title: '《复仇者联盟4：终局之战》', subtitle: '最终选择与遗产', videoId: 'TcMBFSGVi1c',
    copy: '故事最终把能力与责任放在同一个瞬间检验。装甲提供执行选择的力量，却不能替人决定代价。真正留下的，是对家人、伙伴与后来者产生的持续影响。',
    link: 'https://www.youtube.com/watch?v=TcMBFSGVi1c',
  },
];

export const timeline = [
  { key: 'SURVIVE', cn: '先活下来', note: '危机迫使技术第一次转向自救，也让选择成为系统的真正起点。', value: '01' },
  { key: 'REBUILD', cn: '承认错误并重做', note: '升级不是掩盖失败，而是把错误写进下一版设计原则。', value: '02' },
  { key: 'ASSEMBLE', cn: '从个人系统走向团队', note: '最复杂的协作不是联网，而是允许不同判断共同承担结果。', value: '03' },
  { key: 'LEGACY', cn: '留下比装甲更持久的东西', note: '技术会过时，选择塑造的关系、责任和勇气仍会继续运转。', value: '04' },
];
